import type { SVGProps } from 'react';
const SvgArrowSmallUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="m4 10 3.812-3.92A.27.27 0 0 1 8 6a.26.26 0 0 1 .188.08L12 10"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgArrowSmallUp;
